import { NAVIGATION_HEIGHT } from '@/modules/constants/navigation';
import zIndex from '@/modules/constants/zIndex';
import { styled, designTokens } from '@volkswagen-onehub/components-core';

interface OverlayProps {
  onlyMobile?: boolean;
  background?: string;
  removePadding?: boolean;
}

interface OverlayHeaderProps {
  border?: boolean;
}

interface OverlayBodyProps {
  padding?: string;
  scroll?: boolean;
}

export const Overlay = styled.div<OverlayProps>(
  ({ theme, background, removePadding }) => `
  display: flex;
  position: fixed;
  flex-direction: column;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: scroll;
  ${
    removePadding
      ? `
  padding-top: ${NAVIGATION_HEIGHT}px;
  `
      : `
  padding: ${NAVIGATION_HEIGHT}px ${theme.size.dynamic0100} ${theme.size.dynamic0100};
  `
  }

  z-index: ${zIndex.MODAL};
  background: ${background ?? theme.colors.background.primary};
`
);

export const Gradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    179deg,
    rgba(223, 228, 232, 0.54) -30.06%,
    rgba(223, 228, 232, 0) 106.05%
  );
  z-index: ${zIndex.BACKGROUND};
`;

export const StyledOverlayHeader = styled.div<OverlayHeaderProps>(
  ({ theme, border }) => `
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // Percentage offset value is taken from the size of the grid item used in the VW Global nav
  padding: ${theme.size.dynamic0100} calc(4.16667% - ${
    theme.size.dynamic0100
  });   
  border-bottom: ${
    border ? `1px solid ${theme.colors.border.default}` : 'none'
  };

  .individual-price-wrapper {
    justify-content: flex-start;
  }
`
);

export const OverlayBody = styled.div<OverlayBodyProps>(
  ({ theme, padding, scroll }) => `
    padding: ${padding ?? `${theme.size.dynamic0100} 0 0 0`};
    flex: 1;
    ${scroll && 'overflow-y: auto;'}
  `
);

export const IconWrapper = styled.div`
  margin-left: ${(props) => props.theme.size.dynamic0040};
`;
